import React, { useState, useEffect } from "react";
import { Button, Card, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import EmailPhoneCombine from "../../jsx/components/fields/emailPhoneField";
import PrimaryButton from "../../jsx/components/button/primaryButton";
import "./sendVideoLink.scss";
import videoImg from "../../icons/photos/sendVideoLinkPhoto.png";
import TextArea from "../../jsx/components/fields/textArea";
import { useNavigate } from "react-router-dom";
import { MdContentCopy } from "react-icons/md";
import avatarList from '../../media/images/proDashboardAssets/avatarList.png'

import DatePicker from 'react-datepicker';
import { format } from 'date-fns';
import calendarImg from '../../media/images/servicesAssets/calendarImg.png'

import {
  emailValidation,
  noSpaceOnChange,

  phoneValidation,
} from "../../validations/validation";
import { useDispatch, useSelector } from "react-redux";
import sendLink from "../../service/api/video/sendVideoLink";
import { validMobileNumberText } from "../../dataBaseFile/error";
import { txtMessage, txtSendVideoLink, txtTypeComments } from "../../dataBaseFile/label";
import { btnSendLink } from "../../dataBaseFile/alert";
import InputField from "../../jsx/components/fields/inputField";
import ResponceToaster from "../../jsx/components/responceToaster/responceToaster";
import { CountryCodes } from "validator/lib/isISO31661Alpha2";
import AcceptRejectModal from "../../jsx/components/modalAcceptReject/modalAcceptreject";
import { setUserProfileTab } from "../../feature/userData/userData";
const SendVideoLink = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { permissionArr, userName, isSubscribedUser, companyId, remainingVideoInvitationCount, subscriptionId, totalMonthlyFreeVideoLinkCount, doingBusinessAsName } = useSelector((state) => state.user);

  const [isEmailPhoneVal, setIsEmailPhoneVal] = useState(false);
  const [emailPhoneValue, setEmailPhoneValue] = useState("");
  const [codeValue, setCodeValue] = useState(1);
  const [isPhone, setIsPhone] = useState(false);
  const [message, setMessage] = useState(`${userName?.split(" ", 1)} ${doingBusinessAsName ? `from ${doingBusinessAsName} ` : ''}is inviting you to video chat so they can assist you`);
  const [loaderActive, setLoaderActive] = useState(false)
  const [scheduleLoader, setScheduleLoader] = useState(false)

  const [responceMsg, setResponceMsg] = useState("");
  const [toasterType, setToasterType] = useState('');
  const [handleToaster, setHandleToaster] = useState(false);

  const [sendVideoLinkText, setSendVideoLinkText] = useState('');

  const [isSubscriptionExpired, setIsSubscriptionExpired] = useState(false);
  const permissionArray = permissionArr[0] || []

  const handleSubmit = (e) => {
    e.preventDefault();
    if (phoneValidation(emailPhoneValue) || emailValidation(emailPhoneValue)) {
      setLoaderActive(true);
      if (isPhone) {
        let details = {
          user_id_ids: localStorage.getItem("user_id"),
          email_chr: "",
          phone_code_id_int: parseInt(codeValue) || 1,
          phone_number_int: parseInt(emailPhoneValue),
          message_to_end_user_chr: message,
        };


        const data = new FormData();
        data.append("user_id_ids", localStorage.getItem("user_id"));
        data.append("email_chr", "");
        data.append("phone_code_id_int", parseInt(codeValue) || 1);
        data.append("phone_number_int", parseInt(emailPhoneValue));
        data.append("message_to_end_user_chr", message);
        data.append("room_type_chr", "group");
        dispatch(
          sendLink(
            data,
            (res) => {
              localStorage.setItem("triggerFlag", 1);
              localStorage.setItem("roomCode", res.data.data.room_id);
              // localStorage.setItem("call_log_id",res.data.data.room_id)

              navigate("/videoCall");
              setEmailPhoneValue("");
              setMessage("");
              setLoaderActive(false);

              // setSendVideoLinkText(res.data.deep_link);
              // setTabsToggleSendLink(2);
            },
            (err) => {
              setLoaderActive(false);
              setResponceMsg(err?.data.message);


              setToasterType("error");

              setHandleToaster(true);
              setTimeout(() => {
                setHandleToaster(false);
              }, 11000);


            }
          )
        );
      } else if (!isPhone) {
        let details = {
          user_id_ids: localStorage.getItem("user_id"),
          email_chr: emailPhoneValue,
          phone_code_id_int: null,
          phone_number_int: null,
          message_to_end_user_chr: message,
        };

        const data = new FormData();
        data.append("user_id_ids", localStorage.getItem("user_id"))
        data.append("email_chr", emailPhoneValue)
        data.append("message_to_end_user_chr", message);
        data.append("room_type_chr", "group");
        dispatch(
          sendLink(
            data,
            (res) => {
              localStorage.setItem("triggerFlag", 1);
              localStorage.setItem("roomCode", res.data.data.room_id);
              navigate("/videoCall")

              setEmailPhoneValue("");
              setMessage("");
              setLoaderActive(false);

              // setSendVideoLinkText(res.data.deep_link);
              // setTabsToggleSendLink(2);

            },
            (err) => {
              setLoaderActive(false);
              setResponceMsg(err?.data.message);


              setToasterType("error");

              setHandleToaster(true);
              setTimeout(() => {
                setHandleToaster(false);
              }, 11000);
            }
          )
        );
      }
    } else {
      setIsEmailPhoneVal(true);
      setTabsToggleSendLink(1);
    }
  };


  const handleEmailPhone = (e) => {
    setIsEmailPhoneVal(false);

    noSpaceOnChange(e.target.value) && setEmailPhoneValue(e.target.value);
  };
  const handleDropdownValue = (e) => {
    setCodeValue(e);
  };

  const handleMessage = (e) => {
    setMessage(e.target.value);
  };

  useEffect(() => {
    const dot = ".";
    const leng = emailPhoneValue.length - 1;
    if (!isNaN(emailPhoneValue) && emailPhoneValue.charAt(leng) !== dot) {
      if (emailPhoneValue.length < 11) {
        setIsPhone(true);
      } else {
        setIsPhone(false);
      }
    } else {
      setIsPhone(false);
    }
    if (emailPhoneValue === "") {
      setIsPhone(false);
    }
  }, [emailPhoneValue]);

  function handleEmailPhoneBlur() {
    // if (isPhone) {
    //   if (!phoneValidation(emailPhoneValue)) {
    //     setIsEmailPhoneVal(true);
    //   }
    // } else {
    //   if (!emailValidation(emailPhoneValue)) {
    //     setIsEmailPhoneVal(true);
    //   }
    // }

    if (isPhone) {
      if (emailPhoneValue === "") {
        // setIsEmailPhoneVal(true);
        // setLoginErrorMsg(errEmptyEmailOrPhone);
      } else if (!phoneValidation(emailPhoneValue)) {
        setIsEmailPhoneVal(true);
      }
    } else {
      if (emailPhoneValue === "") {
        // setIsEmailPhoneVal(true);
        // setLoginErrorMsg(errEmptyEmailOrPhone);
      } else if (!emailValidation(emailPhoneValue)) {
        setIsEmailPhoneVal(true);
      }
    }
  }


  const [dateTime, setDateTime] = useState('');
  const [unixTimestamp, setUnixTimestamp] = useState('');
  const [unixEndTime, setUnixEndTime] = useState('');
  const [isDateTimeErr, setIsDateTimeErr] = useState(false);

  const sendInfo = (
    <Tooltip id="tooltip">
      <strong>
        {`Connect to a Customer by A.I. video and get greater insight into the work to be done`}
      </strong>
    </Tooltip>
  );

  const handleDateTime = (e) => {
    setIsDateTimeErr(false);
    const newDateTime = e.target.value;
    // console.log(newDateTime, "Here time");

    setDateTime(newDateTime);
    // console.log(e.target.value);

    // Convert the input value to a Unix timestamp
    const timestamp = new Date(newDateTime).getTime() / 1000;
    setUnixTimestamp(Math.floor(timestamp));
    // console.log(Math.floor(timestamp), "Start timestamp");

    // Calculate the end time by adding one hour (3600 seconds)
    const endTimeStamp = Math.floor(timestamp) + 3600;
    setUnixEndTime(endTimeStamp);
    // console.log(endTimeStamp, "End timestamp");
  }

  // Modal functions for the date time confirmation
  const [scheduleModalTrigger, setScheduleModalTrigger] = React.useState(false);
  const handleOpenScheduleModal = () => {
    if (phoneValidation(emailPhoneValue) || emailValidation(emailPhoneValue)) {
      setScheduleModalTrigger(true);
    } else {
      setIsEmailPhoneVal(true);
      setTabsToggleSendLink(1);
    }
  }

  const handleCloseDocScheduleModal = () => {
    setScheduleModalTrigger(false);
    setIsDateTimeErr(false);
    handleClearSchedule();
  };

  const handleClearSchedule = () => {
    setDateTime('');
    setUnixTimestamp('');
    setUnixEndTime('');
    handleSetCurrentDateAndTime();
    setSelectedDate(new Date());
  }

  // New functions for the Schedule call
  const [currentDate, setCurrentDate] = useState('');
  const [currentTime, setCurrentTime] = useState('');

  useEffect(() => {
    handleSetCurrentDateAndTime();
  }, []);

  // const handleSetCurrentDateAndTime = () => {
  //   // Get the current date and time
  //   const now = new Date();
  //   const date = now.toISOString().split('T')[0]; // format yyyy-mm-dd for the date input

  //   // Set the time one hour ahead, format hh:mm for the time input
  //   now.setHours(now.getHours() + 1);
  //   let hours = now.getHours();
  //   let minutes = now.getMinutes();
  //   // Ensure two-digit formatting for hours and minutes
  //   hours = hours < 10 ? `0${hours}` : hours;
  //   minutes = minutes < 10 ? `0${minutes}` : minutes;
  //   const time = `${hours}:${minutes}`;

  //   // Update the state
  //   setCurrentDate(date);
  //   setCurrentTime(time);
  // }

  const handleSetCurrentDateAndTime = () => {
    // Get the current date and time
    const now = new Date();
    const date = now.toISOString().split('T')[0]; // format yyyy-mm-dd for the date input

    // Set the time one hour ahead
    now.setHours(now.getHours() + 1);

    let hours = now.getHours();
    let minutes = now.getMinutes();

    // Adjust minutes to the nearest 30-minute slot
    minutes = minutes < 30 ? 0 : 30;

    // If minutes round up to 0 and it causes the hour to increase (e.g., 23:59 -> 00:00)
    if (minutes === 0 && now.getMinutes() >= 30) {
      hours += 1;
    }

    // Ensure two-digit formatting for hours and minutes
    hours = hours < 10 ? `0${hours}` : hours;
    minutes = minutes === 0 ? `00` : `30`;

    const time = `${hours}:${minutes}`;

    // Update the state
    setCurrentDate(date);
    setCurrentTime(time);
  };

  const handleTimeChange = (e) => {
    const value = e.target.value;
    const [hours, minutes] = value.split(':').map(Number);

    // Adjust minutes to nearest valid option (0 or 30)
    const validMinutes = minutes < 15 ? '00' : '30';

    const correctedTime = `${hours.toString().padStart(2, '0')}:${validMinutes}`;
    setCurrentTime(correctedTime);
  };



  // console.log(currentDate, "Date current");
  // console.log(currentTime, "Time");

  const convertToUnixTime = () => {
    // Combine the date and time into a single Date object
    const combinedDateTime = new Date(`${currentDate}T${currentTime}`);
    // Convert to Unix timestamp
    return Math.floor(combinedDateTime.getTime() / 1000);
  };



  const calculateEndTime = (unixTime) => {
    // Adding 3600 seconds (1 hour) to the current unix timestamp
    return unixTime + 3600;
  };

  const handleSubmitUnixTime = () => {
    const startTime = convertToUnixTime();
    const endTime = calculateEndTime(startTime);

    // console.log('Start Unix Timestamp:', startTime);
    // console.log('End Unix Timestamp:', endTime);

  };

  const handleSubmitSchedule = () => {

    const startTimeUnix = convertToUnixTime();
    const endTimeUnix = calculateEndTime(startTimeUnix);

    // console.log('Start Unix Timestamp:', startTimeUnix);
    // console.log('End Unix Timestamp:', endTimeUnix);

    setScheduleLoader(true);
    if (isPhone) {
      const data = new FormData();
      data.append("user_id_ids", localStorage.getItem("user_id"));
      data.append("email_chr", "");
      data.append("phone_code_id_int", parseInt(codeValue) || 1);
      data.append("phone_number_int", parseInt(emailPhoneValue));
      data.append("message_to_end_user_chr", message);
      data.append("is_scheduling_flag", 1);
      data.append("unix_datetime_stamp_start", startTimeUnix);
      data.append("unix_datetime_stamp_end", endTimeUnix);
      data.append("room_type_chr", "group");
      dispatch(
        sendLink(
          data,
          (res) => {
            // localStorage.setItem("triggerFlag", 1);
            // localStorage.setItem("roomCode", res.data.data.room_id);
            // localStorage.setItem("call_log_id",res.data.data.room_id)
            // navigate("/videoCall")
            // console.log(res)
            setSendVideoLinkText(res.data.deep_link);

            handleCloseDocScheduleModal();

            setEmailPhoneValue("");
            // setMessage("");
            setScheduleLoader(false);

            setResponceMsg(res.data.message);
            setToasterType("success");
            setHandleToaster(true);
            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);

          },
          (err) => {
            // console.log(err)

            setScheduleLoader(false);

            setResponceMsg(err.data.message)
            setToasterType("error")
            setHandleToaster(true);
            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);
          }
        )
      );
    } else if (!isPhone) {
      let details = {
        user_id_ids: localStorage.getItem("user_id"),
        email_chr: emailPhoneValue,
        phone_code_id_int: null,
        phone_number_int: null,
        message_to_end_user_chr: message,
      };

      const data = new FormData();
      data.append("user_id_ids", localStorage.getItem("user_id"))
      data.append("email_chr", emailPhoneValue)
      data.append("phone_code_id_int", 0);
      data.append("phone_number_int", 0);
      data.append("message_to_end_user_chr", message);
      data.append("is_scheduling_flag", 1);
      data.append("unix_datetime_stamp_start", startTimeUnix);
      data.append("unix_datetime_stamp_end", endTimeUnix);
      data.append("room_type_chr", "group");
      dispatch(
        sendLink(
          data,
          (res) => {
            // localStorage.setItem("triggerFlag", 1);
            // localStorage.setItem("roomCode", res.data.data.room_id);
            // navigate("/videoCall")
            // console.log(res)
            setSendVideoLinkText(res.data.deep_link);

            handleCloseDocScheduleModal();
            setEmailPhoneValue("");
            // setMessage("");
            setScheduleLoader(false);

            setResponceMsg(res.data.message)
            setToasterType("success")
            setHandleToaster(true);
            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);

          },
          (err) => {
            // console.log(err)
            setScheduleLoader(false);

            setResponceMsg(err.data.message)
            setToasterType("error")

            setHandleToaster(true);
            setTimeout(() => {
              setHandleToaster(false);
            }, 11000)
          }
        )
      );
    }

  }

  const [tabsToggleSendLink, setTabsToggleSendLink] = useState(1);


  const copyToClipboard = () => {
    navigator.clipboard.writeText(`${sendVideoLinkText}`);
    setResponceMsg("Link copied to clipboard!");
    setToasterType("success");

    setHandleToaster(true);
    setTimeout(() => {
      setHandleToaster(false);
    }, 11000);
  }

  // New calendar functions start here
  const [selectedDate, setSelectedDate] = useState(new Date()); // Initialize with current date or null

  const handleDateChange = date => {
    // Format the date when it is selected and log it or use it as needed
    const formattedDate = format(date, 'yyyy-MM-dd');
    // console.log(formattedDate, "Formated date"); // Outputs the date in "2024-04-24" format
    setCurrentDate(formattedDate);
    setSelectedDate(date);
  };

  // console.log(currentDate, "Date current");
  // console.log(selectedDate, "selectDate here");
  const today = new Date();

  // Format the unix time in given format
  function formatUnixTimestamp(unixTimestamp) {
    const date = new Date(unixTimestamp * 1000);

    const month = date.toLocaleString('default', { month: 'short' });
    const day = date.getDate();
    let hour = date.getHours();
    const minute = date.getMinutes();

    const hourFormatted = hour % 12 || 12; // Convert 24-hour time to 12-hour format
    const amPm = hour < 12 ? 'am' : 'pm';
    const minuteFormatted = minute < 10 ? `0${minute}` : minute;

    return `${month} ${day}, ${hourFormatted}:${minuteFormatted} ${amPm}`;
  }

  return (
    <>
      <>
        <div
          className='h-100 mx-0 row shadow-lg w-100 sendLinkMainConatainer'
        >
          <div className=' col-12 p-3 d-flex flex-column justify-content-between' >
            <div>

              <div className='font-w500 fs-5 mt-2 mx-0 row'>
                <div className='align-items-center col-12 d-flex fs-4 fw-bold justify-content-center px-0 position-relative'>
                  <img src={avatarList} alt="logo" style={{ height: '35px' }} />
                  <span className="position-absolute top-0 start-0 ">
                    <OverlayTrigger placement="bottom" overlay={sendInfo}>
                      <i className="bi bi-info-circle text-hovered cursor-pointer"></i>
                    </OverlayTrigger>
                  </span>
                </div>
              </div>


              <div className='font-w500 fs-5 my-3 mx-0 row '>
                <div className='align-items-center col-12 d-flex fs-4 fw-bold justify-content-center px-0'>

                  <span className="text-black">{"Send a Video Connection"}</span>
                </div>
              </div>
              <span className="text-black fs-7" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>{"Connect with a customer or a employee by AI video chat and do more remotely"}</span>
              {/* Navigations send link */}
              <div className='border-bottom m-0 mt-2 mb-1 overflow-auto row text-nowrap user-profile-nav-bar whitespace-nowrap'>
                <div className='col-12 d-flex px-0 font-w500'>
                  <div onClick={() => setTabsToggleSendLink(1)} className='text-hovered col-6 px-0 align-items-cente cursor-pointer d-flex justify-content-center position-relative px-3 py-2' style={{}}>
                    <span className={`text-hovered ${tabsToggleSendLink === 1 ? "text-black" : "text-grey"} ${tabsToggleSendLink === 1 && "fw-bold"}`} >{"Email or SMS"}</span>
                    {tabsToggleSendLink === 1 && <div className='position-absolute w-100 bottom-0 active-tab-bottom' > </div>}
                  </div>

                  <div onClick={() => setTabsToggleSendLink(2)} className='text-hovered col-6 px-0 align-items-cente cursor-pointer d-flex justify-content-center position-relative px-3 py-2' style={{}}>
                    <span className={`text-hovered ${tabsToggleSendLink === 2 ? "text-black" : "text-grey"} ${tabsToggleSendLink === 2 && "fw-bold"}`}>{"Copy link"}</span>
                    {tabsToggleSendLink === 2 && <div className='position-absolute w-100  bottom-0 active-tab-bottom'> </div>}
                  </div>

                </div>
              </div>

              {tabsToggleSendLink === 1 &&
                <>
                  <div className=' mx-0 row'>
                    <div className='col-12 px-0'>
                      <EmailPhoneCombine
                        inputValue={emailPhoneValue}
                        handleChangeCode={handleDropdownValue}
                        handleInputValue={handleEmailPhone}
                        isEnteringNumber={isPhone}
                        setIsEnteringNumber={setIsPhone}
                        errorOccured={isEmailPhoneVal}
                        errorMessage={validMobileNumberText}
                        handleOnBlur={handleEmailPhoneBlur}
                        defaultCodeValue={codeValue}
                        // label={'Email or Phone'}
                        isRequired={true}
                      />
                    </div>
                  </div>

                  <div className='mt-2 mx-0 row'>
                    <div className='col-12 px-0'>
                      <TextArea
                        labelName={txtMessage}
                        placeholder={txtTypeComments}
                        value={message}
                        onChange={handleMessage}
                        onBlur={() => { }}
                      />
                    </div>
                  </div>
                </>
              }

              {tabsToggleSendLink === 2 &&
                <>
                  <div className=' mx-0 row mt-4 text-center'>
                    <div className='col-12 px-0'>
                      <span>
                        {"You can copy and send a video call link to your customer via any messenger you use for communication."}
                      </span>

                    </div>
                  </div>

                  <div className=' mx-0 row mt-4 text-center'>
                    <div className='col-12 px-0'>
                      <span>
                        {" After that, start the video call and wait for your customer to join it."}
                      </span>

                    </div>
                  </div>

                  <div className=' mx-0 row mt-4 p-1 rounded shadow-sm'
                    style={{
                      background: 'rgba(244, 248, 255, 1)',
                      border: '1px solid rgba(199, 212, 234, 1)',
                    }}
                  >
                    <div className='col-11 px-0 d-flex  '>

                      <div className='overflow-hidden p-2  text-nowrap w-100 whitespace-nowrap' style={{ textOverflow: "ellipsis" }}>
                        <span>
                          {sendVideoLinkText ? <>{`${sendVideoLinkText}`}</> : <>{"You have not send video link yet"}</>}
                        </span>
                      </div>

                    </div>
                    <div className='col-1 px-0 fs-3 d-flex align-items-center justify-content-end text-black pe-2' style={{}}>
                      <div className="tooltipCustom ">
                        <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Copy to clipboard"}</span>
                        <span onClick={() => { copyToClipboard() }} className={`cursor-pointer ${sendVideoLinkText ? "op9" : "op2"}`} style={{ pointerEvents: sendVideoLinkText ? "auto" : "none", }}>
                          <MdContentCopy />
                        </span>
                      </div>
                    </div>
                  </div>
                </>
              }

            </div>

            <div className='row mx-0  w-100 mt-2'>

              {!subscriptionId && <div className="col-12 d-flex justify-content-center align-items-center text-center my-2 font-w600">
                <span>
                  {`You have ${remainingVideoInvitationCount} out of ${totalMonthlyFreeVideoLinkCount} video invitations remaining`}
                </span>
              </div>}

              <div className='col-12 px-0'>

                <div className='d-flex'>
                  <div onClick={() => {
                    if (!isSubscribedUser && remainingVideoInvitationCount === 0) {
                      setIsSubscriptionExpired(true)
                    } else {
                      handleOpenScheduleModal()
                    }
                  }} className='align-items-center font-w600 rounded-1 cursor-pointer d-flex  px-1 py-2'>
                    <i className="bi bi-calendar4-week pe-2"></i>
                    <div className="text-hovered">
                      <span>{"Call schedule for"} </span>
                      <i className="bi bi-chevron-right ps-1 hovered-arrow"></i>
                    </div>

                  </div>
                  <div className='align-items-center font-w600 d-flex px-2 py-2 text-black'>
                    <span>Now</span>
                  </div>
                </div>
              </div>



              <div className='col-12 px-0 mt-2'>
                <PrimaryButton
                  // buttonName={sendVideoLinkText ? "JOIN VIDEO CALL" : "SEND CHILLL VIDEO LINK"}
                  buttonName={"SEND CHILLL VIDEO LINK"}
                  isLoading={loaderActive}
                  loadingMessage={"Connecting..."}
                  onClick={(e) => {
                    if (!isSubscribedUser && remainingVideoInvitationCount === 0) {
                      setIsSubscriptionExpired(true)
                    } else {

                      handleSubmit(e)

                      // Send video link flow updated
                      // if (sendVideoLinkText) {
                      //   localStorage.setItem("triggerFlag", 1);
                      //   navigate("/videoCall");
                      // } else {
                      //   handleSubmit(e)
                      // }

                    }
                    // handleSubmit(e)
                  }}
                  style={{
                    width: '100%',
                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                    border: '2px solid rgba(255, 154, 32, 1)',
                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                  }}
                />
              </div>

            </div>

          </div>
        </div>
      </>
      {/* Modal for previewing the attached image preview */}
      <>

        <Modal
          className="fade"
          show={scheduleModalTrigger}
          size=""
          centered
        // onHide={handleClose} 
        >
          <Modal.Body style={{ padding: '5px' }}>
            <div className="row mx-0">
              <div className="col-12 px-0 position-relative">

                <div
                  className='mx-0 row  schedule-modal-close-btn position-absolute text-hovered '
                  style={{
                    top: '5px',
                    right: '10px',
                  }}
                >
                  <div className='col-12 d-flex fs-4 justify-content-end px-0'>
                    <span onClick={() => handleCloseDocScheduleModal()} className='cursor-pointer'>
                      <i className="bi bi-x-lg"></i>
                    </span>
                  </div>
                </div>

                <div className="row mx-0 ">
                  <div
                    className="col-sm-6 px-2 rounded-1"
                    style={{
                      background: 'rgba(79, 93, 116, 1)',
                    }}
                  >

                    <div className='mx-0 row m-2'>
                      <div className='col-12  px-0 text-center text-white fs-7 fw-light my-3 px-2'>
                        <span>{`Please note that the standard call duration is 20 minutes`}</span>
                      </div>
                    </div>

                    {/* <div className='mx-0 row mb-2'>
                      <div className='col-12  px-0 text-center'>
                        <InputField
                          type="date"
                          labelName={"Date"}
                          value={currentDate}
                          onChange={(e) => setCurrentDate(e.target.value)}
                          errorOccured={isDateTimeErr}
                          errorMeesage={"Please enter date and time"}
                        />
                      </div>
                    </div> */}

                    <div className='mx-0 row'>
                      <div className='col-12  px-0 text-center'>
                        <InputField
                          type="time"
                          labelName={"Time"}
                          placeholder={"Date and time"}
                          value={currentTime}
                          // onChange={(e) => setCurrentTime(e.target.value)}
                          onChange={handleTimeChange}
                          errorOccured={isDateTimeErr}
                          errorMeesage={"Please enter date and time"}
                        />
                      </div>
                    </div>

                    <div className="row mx-0">
                      <div className="col-12 px-0 d-flex justify-content-center">
                        <DatePicker
                          selected={selectedDate}
                          onChange={handleDateChange}
                          // dateFormat="MMMM d, yyyy" // Format of the date displayed
                          // isClearable={true} // Shows a clear button to clear the selection
                          // showYearDropdown
                          scrollableMonthYearDropdown
                          inline // This prop makes the calendar always visible
                          style={{}}
                          minDate={today} // Disables all past dates before today
                          formatWeekDay={nameOfDay => nameOfDay.substring(0, 3)}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-6" style={{}}>

                    <div className="row h-100 w-100">
                      <div className='col-12 p-3 d-flex flex-column justify-content-between'>

                        <div>

                          {/* <div className='mx-0 row text-black'>
                            <div className='col-12 d-flex fs-4 justify-content-end px-0'>
                              <span onClick={() => handleCloseDocScheduleModal()} className='cursor-pointer'>
                                <i className="bi bi-x-lg"></i>
                              </span>
                            </div>
                          </div> */}

                          <div className='mx-0 row text-black my-2'>
                            <div className='col-12 px-0 text-center d-flex align-items-cente justify-content-center'>

                              <img src={calendarImg} alt="Calendar" style={{ height: '70px', width: '70px' }} />
                              {/* <i class="align-self-center bi bi-gear-wide-connected"></i> */}
                            </div>
                          </div>

                          <div className='mx-0 row text-black mb-3'>
                            <div className='col-12 font-w600 fs-3 px-0 text-center'>
                              <span>
                                {"Schedule a call"}
                              </span>
                            </div>
                          </div>

                          <div className='mx-0 row mb-3'>
                            <div className='col-12  px-0 text-center'>
                              <span>{"Set the desired date and time for your video call or set it to go live right now"}</span>
                            </div>
                          </div>

                          <div className='mx-0 row'>
                            <div
                              className='col-12  px-0 text-center rounded p-2 d-flex align-items-center justify-content-center flex-column'
                              style={{
                                background: 'rgba(244, 248, 255, 1)',
                                border: '1px solid rgba(199, 212, 234, 1)',
                              }}
                            >
                              <span>{`Scheduled date & time`}</span>
                              <span className="fs-6 text-black">{`${formatUnixTimestamp(convertToUnixTime())}`}</span>
                            </div>
                          </div>

                        </div>

                        <div>
                          <div className='mx-0 row mt-3'>
                            <div className='col-12  px-0 text-center'>
                              <PrimaryButton
                                buttonName={"SAVE CHANGES"}
                                onClick={() => handleSubmitSchedule()}
                                isLoading={scheduleLoader}
                                loadingMessage={"Saving..."}
                                style={{
                                  width: '100%',
                                  background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                  border: '2px solid rgba(255, 154, 32, 1)',
                                  boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </Modal.Body>
        </Modal>
      </>

      {/* Subscription check */}
      <>
        <AcceptRejectModal
          modalStatus={isSubscriptionExpired}
          text={`${(permissionArray.includes("UPDATE WORK INFORMATION") && !companyId) ? "Please upgrade your subscription to use this feature." : "Your company subscription expired. Please contact the company admin."}`}
          onClickReject={() => {
            setIsSubscriptionExpired(false)
          }}
          onClickAccept={() => {
            setIsSubscriptionExpired(false)
            if ((permissionArray.includes("UPDATE WORK INFORMATION") && !companyId)) {
              dispatch(setUserProfileTab(5))
              navigate('/userProfile')
            }
          }}
          yesBtnTxt={`${(permissionArray.includes("UPDATE WORK INFORMATION") && !companyId) ? "BUY NOW" : "OK"}`}
          noBtnTxt={"NO, GO BACK"}
          isTwoActionsReq={(permissionArray.includes("UPDATE WORK INFORMATION") && !companyId)}
        />
      </>

      {handleToaster && <ResponceToaster toasterType={toasterType} message={responceMsg} />}

    </>
  );
};

export default SendVideoLink;
